import React, { FC } from 'react';
import styled from '@emotion/styled';

import { useLicenses, useStaffCan } from '~Hooks';

import DragChequeToTable from './DragChequeToTable';
import DeleteChequeTarget, { DraggedCheque } from './DeleteChequeTarget';
import { useChequeContext } from '~Scenes/Handy/Context/ChequeContext';

const Targets = styled.span`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  z-index: 10;
  box-sizing: border-box;
  animation: fade-and-translate-left 0.4s ease-in-out;
  padding: 8px 8px 0;
  box-shadow: 0 -7px 14px 1px rgba(0, 0, 0, 0.3);
  & > * {
    margin-bottom: 8px;
  }
  background-color: var(--colorBlueGray1100);
`;

interface Props {
  goToTables?: () => void;
  onDeleteCheque?: (data: DraggedCheque) => void;
}

const DragTargets: FC<Props> = ({ goToTables, onDeleteCheque }) => {
  const { selectedCheque } = useChequeContext();
  const staffCan = useStaffCan();
  // Currently we use REFUND permission
  const staffCanDelete = staffCan.REFUND;
  const staffCanMutate = staffCan.mutateCheque(selectedCheque?.id ?? '');

  const licenses = useLicenses();

  const hasOrderingLicense = licenses.hasHandheldPro || licenses.hasHandheldOrder;

  return (
    <Targets>
      {staffCanDelete && staffCanMutate && onDeleteCheque && (
        <DeleteChequeTarget onDrop={onDeleteCheque} />
      )}
      {hasOrderingLicense && goToTables && <DragChequeToTable goToTables={goToTables} />}
    </Targets>
  );
};

export default DragTargets;
